export const formatCurrency = (amount?: number): string => {
  if (!amount) return 'Not specified';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'ACCEPTED':
      return '#10b981';
    case 'REJECTED':
      return '#ef4444';
    case 'COUNTERED':
      return '#3b82f6';
    case 'SUBMITTED':
      return '#f59e0b';
    case 'RESPONDED':
      return '#3b82f6';
    case 'VIEWED':
      return '#f59e0b';
    case 'SENT':
      return '#6b7280';
    default:
      return '#6b7280';
  }
};

export const getRecipientStatusLabel = (status: string) => {
  switch (status) {
    case 'SENT':
      return 'Sent';
    case 'VIEWED':
      return 'Viewed';
    case 'RESPONDED':
      return 'Responded';
    case 'ACCEPTED':
      return 'Accepted';
    case 'REJECTED':
      return 'Rejected';
    default:
      return status;
  }
};
